import React from "react";
import {ValidationFormField} from "lib/components";
import PropTypes from "prop-types";

export default function EmailInput(props) {
  const {form, name, value, title = "Email Address", onChange, readOnly = false} = props;

  return (
    <ValidationFormField
      form={form}
      type="email"
      required
      fullWidth
      id={name}
      label={title}
      size="small"
      name={name}
      value={value}
      onChange={onChange}
      readOnly={readOnly}
      helperText="Invalid email address"
    />
  );
}

EmailInput.propTypes = {
  form: PropTypes.object,
  name: PropTypes.string,
  value: PropTypes.string,
  title: PropTypes.string,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
};
